import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { ReactElement } from 'react';

import classes from './Forbidden.module.css';

export default function Forbidden(): ReactElement {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.errorCode}>403</div>
        <h1 className={classes.title}>Access Forbidden</h1>
        <p className={classes.description}>You don't have permission to access this resource.</p>
        <Button size="large" href="/orgs" icon={<HomeOutlined />} className={classes.button}>
          Back to Home
        </Button>
      </div>
    </div>
  );
}
